import React, { useMemo, useRef, useState } from 'react'
import Modal from "react-bootstrap/Modal";
import { BASE_URL } from '../../../config/axios';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { AddwithBlueCircle, AddwithWhiteCircle, Eye, Reciept, UpdatePencil } from '../../AllSvg';
import { formatCurrencyIndian, handleErrorToast, isMoreThan24Hours, ViewFile, ViewReciept } from '../../CustomFunctions';
import { AddPaymentReceipt } from './PaymentReceipts';
import { DeleteInvoice } from "../ProjectDetailsCrudButtons";
import { CheckCircle, CloudDownload, FileText, IndianRupee, ReceiptIndianRupeeIcon, Search, X, XCircle } from 'lucide-react';
import { ToastContainer } from 'react-toastify';
import { ConsultancyInvoiceFormat } from './ConsultancyInvoice';

// const InvoiceList = ({ project }) => {
//   const [show, setShow] = useState(false);
//   const [invoice, setInvoice] = useState([]);
//   const handleShow = () => {
//     setShow(true);
//     getInvoice();
//   };
//   const handleClose = () => {
//     setShow(false);
//   };

//   const getInvoice = async () => {
//     try {
//       const response = await axios.get(`${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${project.id}/null/null/`);
//       const sortedInvoices = response.data.sort((a, b) => {
//         if (a.year !== b.year) {
//           return b.year - a.year; // Sort by year first
//         }
//         return b.month - a.month; // If years are the same, sort by month
//       });
//       setInvoice(sortedInvoices);
//     } catch (error) {
//       console.error(error);
//     }
//   };
//   const currentUrl = window.location.href;
//   const urlParts = currentUrl.split("/");
//   const navigate = useNavigate();
//   const p_id = project.id;

//   const ViewInvoice = (invoice_id, month, invoice_number, year) => {
//     navigate(`/${urlParts[3]}/ConsultancyInvoice/${p_id}/${invoice_id}/`, { state: { invoice_id, p_id, month, year, invoice_number } });
//   };
//   const ViewInvoiceDeduction = (invoice_id, month, invoice_number, year) => {
//     navigate(`/${urlParts[3]}/ConsultancyInvoiceDeductions/${p_id}/${invoice_id}/`, { state: { invoice_id, p_id, month, year, invoice_number } });
//   };

//   const ViewPaymentReceipt = (invoice_id, month, invoice_number, year) => {
//     navigate(`/${urlParts[3]}/PrintInvoice/${p_id}/${invoice_id}/`, { state: { invoice_id, p_id, month, year, invoice_number } });
//   };

//   const role = sessionStorage.getItem('sitemanagement_role')

//   return (
//     <>
//       <button
//         className=""
//         title="View Invoice"
//         onClick={handleShow}
//       >
//         <Eye />
//       </button>
//       <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
//         <Modal.Header closeButton>
//           <Modal.Title> Invoice List </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="table-css-white-background">
//             <table className="table-css">
//               <thead>
//                 <tr className="custom-table-head-tr-with-less-padding">
//                   <th className="table-heading-text">S.No.</th>
//                   <th className="table-heading-text text-center">Invoice Number</th>
//                   <th className="table-heading-text text-center">Month</th>
//                   <th className="table-heading-text text-center">Year</th>
//                   <th className="table-heading-text text-center">View Invoice</th>
//                   <th className="table-heading-text text-center">View Invoice Deduction</th>
//                   <th className="table-heading-text text-end">Payment Receipt</th>
//                   {role !== "ViewAccess" &&
//                     <th className="table-heading-text text-end">Delete Invoice</th>
//                   }
//                 </tr>
//               </thead>
//               <tbody>
//                 {invoice.map((i, index) => (
//                   <React.Fragment key={index}>
//                     <tr className="custom-table-head-td">
//                       <td className="table-body">{index + 1}</td>
//                       <td className="table-body text-center">{i.invoice_number}</td>
//                       <td className="table-body text-center">{i.month}</td>
//                       <td className="table-body text-center">{i.year}</td>
//                       <td className="table-body text-center">
//                         <button
//                           onClick={() => ViewInvoice(i.id, i.month, i.invoice_number, i.year)}
//                           title="View Invoice Details"
//                         >
//                           <Eye />
//                         </button>

//                       </td>
//                       <td className="table-body text-center">
//                         <button
//                           onClick={() => ViewInvoiceDeduction(i.id, i.month, i.invoice_number, i.year)}
//                           title="View Invoice Deduction Details"
//                         >
//                           <Eye />
//                         </button>

//                       </td>
//                       <td className="table-body text-center width-5vw  justify-between">
//                         <div style={{ display: 'flex', gap: '20px' }}>
//                           <button
//                             onClick={() => ViewPaymentReceipt(i.id, i.month, i.invoice_number, i.year)}
//                             title="View PaymentReceipt Details"
//                             className=""
//                           >
//                             <Reciept />
//                           </button>
//                           {/* <ViewReciept filename={i.invoice_number} filesrc={i.invoice_number} /> */}
//                         </div>
//                       </td>
//                       {role !== "ViewAccess" &&
//                         <td className="table-body text-center width-5vw justify-between">
//                           {(role === "Checker" && !isMoreThan24Hours(i.created_at)) || role !== "Checker" ? (
//                             <DeleteInvoice i={i} getInvoice={getInvoice} />
//                           ) : (
//                             "-"
//                           )}
//                         </td>
//                       }


//                     </tr>
//                   </React.Fragment>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };

// const InvoiceList = ({ project }) => {
//   const [show, setShow] = useState(false);
//   const [invoice, setInvoice] = useState([]);
//   const [buffer, setBuffering] = useState(true);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [downloadTarget, setDownloadTarget] = useState(null); // { id, month, invoice_number, year }
//   const [downloadingId, setDownloadingId] = useState(null);
//   const exportRef = useRef(null);

//   const handleShow = () => {
//     setShow(true);
//     getInvoice();
//   };
//   const handleClose = () => {
//     setShow(false);
//   };

//   const getInvoice = async () => {
//     setBuffering(true);
//     try {
//       const response = await axios.get(`${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${project.id}/null/null/`);
//       const sortedInvoices = response.data.sort((a, b) => {
//         if (a.year !== b.year) {
//           return b.year - a.year; // Sort by year first
//         }
//         return b.month - a.month; // If years are the same, sort by month
//       });
//       setInvoice(sortedInvoices);
//     } catch (error) {
//       handleErrorToast(error);
//     } finally {
//       setBuffering(false);
//     }
//   };

//   const currentUrl = window.location.href;
//   const urlParts = currentUrl.split("/");
//   const navigate = useNavigate();
//   const p_id = project.id;

//   const ViewInvoice = (invoice_id, month, invoice_number, year) => {
//     navigate(`/${urlParts[3]}/ConsultancyInvoice/${p_id}/${invoice_id}/`, { state: { invoice_id, p_id, month, year, invoice_number } });
//   };
//   const ViewInvoiceDeduction = (invoice_id, month, invoice_number, year) => {
//     navigate(`/${urlParts[3]}/ConsultancyInvoiceDeductions/${p_id}/${invoice_id}/`, { state: { invoice_id, p_id, month, year, invoice_number } });
//   };

//   const ViewPaymentReceipt = (invoice_id, month, invoice_number, year) => {
//     navigate(`/${urlParts[3]}/PrintInvoice/${p_id}/${invoice_id}/`, { state: { invoice_id, p_id, month, year, invoice_number } });
//   };

//   const role = sessionStorage.getItem('sitemanagement_role')

//   const filteredInvoice = invoice?.filter((i) =>
//     i.invoice_number?.toString().toLowerCase().includes(searchQuery.toLowerCase()) ||
//     i.month?.toString().toLowerCase().includes(searchQuery.toLowerCase()) ||
//     i.year?.toString().includes(searchQuery.toLowerCase())
//   );
//   const handleDownloadInvoice = (i) => {
//     setDownloadingId(i.id);
//     setDownloadTarget({
//       invoice_id: i.id,
//       p_id: p_id,
//       month: i.month,
//       year: i.year,
//       invoice_number: i.invoice_number,
//     });
//   };
//   const handleExportReady = () => {
//     setTimeout(() => {
//       exportRef.current?.exportExcel?.();
//       setDownloadingId(null);
//       setDownloadTarget(null);
//     }, 1500);
//   };


//   return (
//     <>
//       <button title="View Invoice" className="model-delete-button-modern actionn-icon" style={{ backgroundColor: "#00000075" }} onClick={handleShow}>
//         <FileText size={16} color="#fff" />
//       </button>

//       <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="lg">
//         <Modal.Header className="modern-modal-header">
//           <div className="header-content">
//             <div style={{ color: "white" }}>
//               <ReceiptIndianRupeeIcon size={24} />
//             </div>
//             <div>
//               <Modal.Title>Invoice List</Modal.Title>
//               <p className="header-subtitle" style={{ color: "white" }}>
//                 {project?.project_short_name ? `Invoices for ${project.project_short_name}` : "All invoices for this project"}
//               </p>
//             </div>
//           </div>
//           <button className="close-btn" onClick={handleClose}>
//             <X size={20} />
//           </button>
//         </Modal.Header>

//         <Modal.Body className="modern-modal-body">
//           <div className="table-css-white-background">
//             <div className="table-heading-flex">
//               <div className="flex-row">
//                 <div className="table-searchh">
//                   <div>
//                     <Search size={14} color="#2B3674" />
//                   </div>
//                   <div>
//                     <input
//                       placeholder="Search"
//                       className="navbar-inputt font-weight400  font-size-text"
//                       value={searchQuery}
//                       onChange={(e) => setSearchQuery(e.target.value)}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {buffer ? (
//               <div className="loader" style={{ width: "100%" }}>
//                 <div className="child"></div>
//               </div>
//             ) : (
//               <table className="table-css">
//                 <thead>
//                   <tr className="custom-table-head-tr-with-less-padding">
//                     <th className="table-heading-text">S.No.</th>
//                     <th className="table-heading-text text-center">Invoice Number</th>
//                     <th className="table-heading-text text-center">Month</th>
//                     <th className="table-heading-text text-center">Year</th>
//                     <th className="table-heading-text text-center">View Invoice</th>
//                     <th className="table-heading-text text-center">View Invoice Deduction</th>
//                     <th className="table-heading-text text-center">Payment Receipt</th>
//                     {role !== "ViewAccess" &&
//                       <th className="table-heading-text text-center">Delete Invoice</th>
//                     }
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredInvoice?.length > 0 ? (
//                     filteredInvoice.map((i, index) => (
//                       <tr className="custom-table-head-td" key={index}>
//                         <td className="table-body">{index + 1}</td>
//                         <td className="table-body text-center">{i.invoice_number}</td>
//                         <td className="table-body text-center">{i.month}</td>
//                         <td className="table-body text-center">{i.year}</td>
//                         <td className="table-body text-center">
//                           <button
//                             className="model-delete-button-modern actionn-icon" style={{ backgroundColor: "#00000075" }} style={{ background: "#00000075" }}
//                             onClick={() => ViewInvoice(i.id, i.month, i.invoice_number, i.year)}
//                             title="View Invoice Details"
//                           >
//                             <FileText size={14} color="#fff" />
//                           </button>
//                         </td>
//                         <td className="table-body text-center">
//                           <button
//                             className="model-delete-button-modern actionn-icon" style={{ backgroundColor: "#00000075" }} style={{ background: "#00000075" }}
//                             onClick={() => ViewInvoiceDeduction(i.id, i.month, i.invoice_number, i.year)}
//                             title="View Invoice Deduction Details"
//                           >
//                             <FileText size={14} color="#fff" />
//                           </button>
//                         </td>
//                         <td className="table-body text-center">
//                           <button
//                             className="model-delete-button-modern actionn-icon" style={{ backgroundColor: "#00000075" }} style={{ background: "#00000075" }}
//                             onClick={() => ViewPaymentReceipt(i.id, i.month, i.invoice_number, i.year)}
//                             title="View Payment Receipt Details"
//                           >
//                             <ReceiptIndianRupeeIcon size={20} color="#fff" />
//                           </button>
//                         </td>
//                         <td className="table-body text-center">
//                           <button
//                             className="model-delete-button-modern actionn-icon"
//                             style={{ background: "#1e7e34" }}
//                             onClick={() => handleDownloadInvoice(i)}
//                             disabled={downloadingId === i.id}
//                             title="Download Excel"
//                           >
//                             {downloadingId === i.id
//                               ? <span className="loader-tiny" />
//                               : <FileText size={14} color="#fff" />
//                             }
//                           </button>
//                         </td>

//                         {role !== "ViewAccess" &&
//                           <td className="table-body text-center">
//                             {(role === "Checker" && !isMoreThan24Hours(i.created_at)) || role !== "Checker" ? (
//                               <DeleteInvoice i={i} getInvoice={getInvoice} />
//                             ) : (
//                               "-"
//                             )}
//                           </td>
//                         }
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan={role !== "ViewAccess" ? 8 : 7} className="align-center">
//                         No invoices found
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             )}
//           </div>

//           <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };


// const InvoiceList = ({ project }) => {
//   const [show, setShow] = useState(false);
//   const [invoice, setInvoice] = useState([]);
//   const [buffer, setBuffering] = useState(true);
//   const [searchQuery, setSearchQuery] = useState("");

//   // Raised invoice export state
//   const [invoiceDownloadTarget, setInvoiceDownloadTarget] = useState(null);
//   const [invoiceDownloadingId, setInvoiceDownloadingId] = useState(null);
//   const invoiceExportRef = useRef(null);

//   // Deduction export state
//   const [deductionDownloadTarget, setDeductionDownloadTarget] = useState(null);
//   const [deductionDownloadingId, setDeductionDownloadingId] = useState(null);
//   const deductionExportRef = useRef(null);

//   const handleShow = () => {
//     setShow(true);
//     getInvoice();
//   };
//   const handleClose = () => setShow(false);

//   const getInvoice = async () => {
//     setBuffering(true);
//     try {
//       const response = await axios.get(`${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${project.id}/null/null/`);
//       const sortedInvoices = response.data.sort((a, b) => {
//         if (a.year !== b.year) return b.year - a.year;
//         return b.month - a.month;
//       });
//       setInvoice(sortedInvoices);
//     } catch (error) {
//       handleErrorToast(error);
//     } finally {
//       setBuffering(false);
//     }
//   };

//   const currentUrl = window.location.href;
//   const urlParts = currentUrl.split("/");
//   const navigate = useNavigate();
//   const p_id = project.id;

//   const ViewInvoice = (invoice_id, month, invoice_number, year) => {
//     navigate(`/${urlParts[3]}/ConsultancyInvoice/${p_id}/${invoice_id}/`, { state: { invoice_id, p_id, month, year, invoice_number } });
//   };
//   const ViewInvoiceDeduction = (invoice_id, month, invoice_number, year) => {
//     navigate(`/${urlParts[3]}/ConsultancyInvoiceDeductions/${p_id}/${invoice_id}/`, { state: { invoice_id, p_id, month, year, invoice_number } });
//   };
//   const ViewPaymentReceipt = (invoice_id, month, invoice_number, year) => {
//     navigate(`/${urlParts[3]}/PrintInvoice/${p_id}/${invoice_id}/`, { state: { invoice_id, p_id, month, year, invoice_number } });
//   };

//   const role = sessionStorage.getItem('sitemanagement_role');

//   const filteredInvoice = invoice?.filter((i) =>
//     i.invoice_number?.toString().toLowerCase().includes(searchQuery.toLowerCase()) ||
//     i.month?.toString().toLowerCase().includes(searchQuery.toLowerCase()) ||
//     i.year?.toString().includes(searchQuery.toLowerCase())
//   );

//   // ── Raised invoice download ──────────────────────────────
//   const handleDownloadInvoice = (i) => {
//     setInvoiceDownloadingId(i.id);
//     setInvoiceDownloadTarget({
//       invoice_id: i.id, p_id, month: i.month, year: i.year, invoice_number: i.invoice_number,
//     });
//   };
//   const handleInvoiceExportReady = () => {
//     setTimeout(() => {
//       invoiceExportRef.current?.exportExcel?.();
//       setInvoiceDownloadingId(null);
//       setInvoiceDownloadTarget(null);
//     }, 1500);
//   };

//   // ── Deduction download ────────────────────────────────────
//   const handleDownloadDeduction = (i) => {
//     setDeductionDownloadingId(i.id);
//     setDeductionDownloadTarget({
//       invoice_id: i.id, p_id, month: i.month, year: i.year, invoice_number: i.invoice_number,
//     });
//   };
//   const handleDeductionExportReady = () => {
//     setTimeout(() => {
//       deductionExportRef.current?.exportExcel?.();
//       setDeductionDownloadingId(null);
//       setDeductionDownloadTarget(null);
//     }, 1500);
//   };

//   return (
//     <>
//       <button title="View Invoice" className="model-delete-button-modern actionn-icon" style={{ backgroundColor: "#00000075" }} onClick={handleShow}>
//         <FileText size={16} color="#fff" />
//       </button>

//       <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="lg">
//         <Modal.Header className="modern-modal-header">
//           <div className="header-content">
//             <div style={{ color: "white" }}>
//               <ReceiptIndianRupeeIcon size={24} />
//             </div>
//             <div>
//               <Modal.Title>Invoice List</Modal.Title>
//               <p className="header-subtitle" style={{ color: "white" }}>
//                 {project?.project_short_name ? `Invoices for ${project.project_short_name}` : "All invoices for this project"}
//               </p>
//             </div>
//           </div>
//           <button className="close-btn" onClick={handleClose}>
//             <X size={20} />
//           </button>
//         </Modal.Header>

//         <Modal.Body className="modern-modal-body">
//           <div className="table-css-white-background">
//             <div className="table-heading-flex">
//               <div className="flex-row">
//                 <div className="table-searchh">
//                   <div><Search size={14} color="#2B3674" /></div>
//                   <div>
//                     <input
//                       placeholder="Search"
//                       className="navbar-inputt font-weight400 font-size-text"
//                       value={searchQuery}
//                       onChange={(e) => setSearchQuery(e.target.value)}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {buffer ? (
//               <div className="loader" style={{ width: "100%" }}>
//                 <div className="child"></div>
//               </div>
//             ) : (
//               <table className="table-css">
//                 <thead>
//                   <tr className="custom-table-head-tr-with-less-padding">
//                     <th className="table-heading-text">S.No.</th>
//                     <th className="table-heading-text text-center">Invoice Number</th>
//                     <th className="table-heading-text text-center">Month</th>
//                     <th className="table-heading-text text-center">Year</th>
//                     <th className="table-heading-text text-center">View Invoice</th>
//                     <th className="table-heading-text text-center">View Invoice Deduction</th>
//                     <th className="table-heading-text text-center">Payment Receipt</th>
//                     <th className="table-heading-text text-center">Download Invoice Excel</th>
//                     <th className="table-heading-text text-center">Download Passed Invoice Excel</th>
//                     {role !== "ViewAccess" &&
//                       <th className="table-heading-text text-center">Delete Invoice</th>
//                     }
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredInvoice?.length > 0 ? (
//                     filteredInvoice.map((i, index) => (
//                       <tr className="custom-table-head-td" key={index}>
//                         <td className="table-body">{index + 1}</td>
//                         <td className="table-body text-center">{i.invoice_number}</td>
//                         <td className="table-body text-center">{i.month}</td>
//                         <td className="table-body text-center">{i.year}</td>
//                         <td className="table-body text-center">
//                           <button
//                             className="model-delete-button-modern actionn-icon"
//                             style={{ background: "#00000075" }}
//                             onClick={() => ViewInvoice(i.id, i.month, i.invoice_number, i.year)}
//                             title="View Invoice Details"
//                           >
//                             <FileText size={14} color="#fff" />
//                           </button>
//                         </td>
//                         <td className="table-body text-center">
//                           <button
//                             className="model-delete-button-modern actionn-icon"
//                             style={{ background: "#00000075" }}
//                             onClick={() => ViewInvoiceDeduction(i.id, i.month, i.invoice_number, i.year)}
//                             title="View Invoice Deduction Details"
//                           >
//                             <FileText size={14} color="#fff" />
//                           </button>
//                         </td>
//                         <td className="table-body text-center">
//                           <button
//                             className="model-delete-button-modern actionn-icon"
//                             style={{ background: "#00000075" }}
//                             onClick={() => ViewPaymentReceipt(i.id, i.month, i.invoice_number, i.year)}
//                             title="View Payment Receipt Details"
//                           >
//                             <ReceiptIndianRupeeIcon size={20} color="#fff" />
//                           </button>
//                         </td>

//                         {/* Download raised invoice excel */}
//                         <td className="table-body text-center">
//                           <button
//                             className="model-delete-button-modern actionn-icon"
//                             style={{ background: invoiceDownloadingId === i.id ? "#1e7e34" : "#1e7e34", borderRadius: invoiceDownloadingId === i.id ? "5px" : "10px" }}
//                             onClick={() => handleDownloadInvoice(i)}
//                             disabled={invoiceDownloadingId === i.id}
//                             title="Download Invoice Excel"
//                           >
//                             {invoiceDownloadingId === i.id
//                               ? <span className="loader actionn-icon" style={{ color: "#fff", background: invoiceDownloadingId === i.id ? "#1e7e34" : "#1e7e34" }} ><CloudDownload size={14} color="#fff" />Downloading...</span>
//                               : <CloudDownload size={14} color="#fff" />
//                             }
//                           </button>
//                         </td>

//                         {/* Download deduction excel */}
//                         <td className="table-body text-center">
//                           <button
//                             className="model-delete-button-modern actionn-icon"
//                             style={{ background: deductionDownloadingId === i.id ? "#1e7e34" : "#1e7e34", borderRadius: deductionDownloadingId === i.id ? "5px" : "10px" }}
//                             onClick={() => handleDownloadDeduction(i)}
//                             disabled={deductionDownloadingId === i.id}
//                             title="Download Passed Invoice Excel"
//                           >
//                             {deductionDownloadingId === i.id
//                               ? <span className="loader actionn-icon" style={{ color: "#fff", background: deductionDownloadingId === i.id ? "#1e7e34" : "#1e7e34" }} ><CloudDownload size={14} color="#fff" />Downloading...</span>
//                               : <CloudDownload size={14} color="#fff" />
//                             }
//                           </button>
//                         </td>

//                         {role !== "ViewAccess" &&
//                           <td className="table-body text-center">
//                             {(role === "Checker" && !isMoreThan24Hours(i.created_at)) || role !== "Checker" ? (
//                               <DeleteInvoice i={i} getInvoice={getInvoice} />
//                             ) : (
//                               "-"
//                             )}
//                           </td>
//                         }
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan={role !== "ViewAccess" ? 9 : 8} className="align-center">
//                         No invoices found
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             )}
//           </div>

//           <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//         </Modal.Body>
//       </Modal>



//       {deductionDownloadTarget && (
//         <div style={{ position: "absolute", left: "-9999px", top: 0 }}>
//           <ConsultancyInvoiceFormat
//             ref={deductionExportRef}
//             usefor="downloadOnly"
//             p_id={deductionDownloadTarget.p_id}
//             invoice_id={deductionDownloadTarget.invoice_id}
//             month={deductionDownloadTarget.month}
//             year={deductionDownloadTarget.year}
//             invoice_number={deductionDownloadTarget.invoice_number}
//             onExportReady={handleDeductionExportReady}
//           />
//         </div>
//       )}

//       {invoiceDownloadTarget && (
//         <div style={{ position: "absolute", left: "-9999px", top: 0 }}>
//           <ConsultancyInvoiceFormat
//             ref={invoiceExportRef}
//             usefor="downloadOnly"
//             p_id={invoiceDownloadTarget.p_id}
//             invoice_id={invoiceDownloadTarget.invoice_id}
//             month={invoiceDownloadTarget.month}
//             year={invoiceDownloadTarget.year}
//             invoice_number={invoiceDownloadTarget.invoice_number}
//             onExportReady={handleInvoiceExportReady}
//           />
//         </div>
//       )}
//     </>
//   );
// };


const InvoiceList = ({ project }) => {
  const [show, setShow] = useState(false);
  const [invoice, setInvoice] = useState([]);
  const [buffer, setBuffering] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");

  // Raised invoice export state
  const [invoiceDownloadTarget, setInvoiceDownloadTarget] = useState(null);
  const [invoiceDownloadingId, setInvoiceDownloadingId] = useState(null);
  const invoiceExportRef = useRef(null);

  // Deduction export state
  const [deductionDownloadTarget, setDeductionDownloadTarget] = useState(null);
  const [deductionDownloadingId, setDeductionDownloadingId] = useState(null);
  const deductionExportRef = useRef(null);

  const handleShow = () => {
    setShow(true);
    getInvoice();
  };
  const handleClose = () => setShow(false);

  const getInvoice = async () => {
    setBuffering(true);
    try {
      const response = await axios.get(`${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${project.id}/null/null/`);
      const sortedInvoices = response.data.sort((a, b) => {
        if (a.year !== b.year) return b.year - a.year;
        return b.month - a.month;
      });
      setInvoice(sortedInvoices);
      if (sortedInvoices[0]) {
        getLatestInvoiceStats(sortedInvoices[0].id, sortedInvoices[0].month, sortedInvoices[0].year);
      }
    } catch (error) {
      handleErrorToast(error);
    } finally {
      setBuffering(false);
    }
  };

  const [statsBuffer, setStatsBuffer] = useState(true);
  const [latestInvoiceDetails, setLatestInvoiceDetails] = useState(null);

  const getLatestInvoiceStats = async (latestInvoiceId, month, year) => {
    setStatsBuffer(true);
    try {
      const [raisedRes, deductionRes /*, ...aur jo bhi APIs hain */] = await Promise.all([
        axios.get(`${BASE_URL}/siteproject/invoiceemployeebyprojectstatus/${project.id}/${month}/${year}`),
        axios.get(`${BASE_URL}/siteproject/newinvoiceemployeefiltermonthyear/${latestInvoiceId}/${month}/${year}`),
        axios.get(`${BASE_URL}/siteproject/invoicetransportbyprojectstatus/${project.id}/${month}/${year}`),
        axios.get(`${BASE_URL}/siteproject/invoicedutybyprojectstatus/${project.id}/${month}/${year}`),
        axios.get(`${BASE_URL}/siteproject/invoiceofficerentbyprojectstatus/${project.id}/${month}/${year}`),
        axios.get(`${BASE_URL}/siteproject/invoiceofficefurnitureandequipmentstatusbyproject/${project.id}/${month}/${year}`),
        axios.get(`${BASE_URL}/siteproject/invoiceofficesuppliesbyprojectstatus/${project.id}/${month}/${year}`),
        axios.get(`${BASE_URL}/siteproject/invoicereportsanddocprintstatusbyproject/${project.id}/${month}/${year}`),
        axios.get(`${BASE_URL}/siteproject/invoiceroadsurveyequipmentStatusbyproject/${project.id}/${month}/${year}`),

        axios.get(`${BASE_URL}/siteproject/newinvoicetransportationfiltermonthyear/${latestInvoiceId}/null/null/`),
        axios.get(`${BASE_URL}/siteproject/newinvoicedutytravelfiltermonthyear/${latestInvoiceId}/null/null/`),
        axios.get(`${BASE_URL}/siteproject/newinvoiceofficerentfiltermonthyear/${latestInvoiceId}/null/null/`),
        axios.get(`${BASE_URL}/siteproject/newinvoiceofficesuppliesfiltermonthyear/${latestInvoiceId}/null/null/`),
        axios.get(`${BASE_URL}/siteproject/newinvoiceofficefurnitureandequipmentfiltermonthyear/${latestInvoiceId}/null/null/`),
        axios.get(`${BASE_URL}/siteproject/newinvoicereportsanddocumentprintingfiltermonthyear/${latestInvoiceId}/null/null/`),
        axios.get(`${BASE_URL}/siteproject/newinvoiceroadsurveyequipmentfiltermonthyear/${latestInvoiceId}/null/null/`),


      ]);

      setLatestInvoiceDetails({
        raised: raisedRes.data,
        deduction: deductionRes.data,
      });
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setStatsBuffer(false);
    }
  };

  const currentUrl = window.location.href;
  const urlParts = currentUrl.split("/");
  const navigate = useNavigate();
  const p_id = project.id;

  const ViewInvoice = (invoice_id, month, invoice_number, year) => {
    navigate(`/${urlParts[3]}/ConsultancyInvoice/${p_id}/${invoice_id}/`, { state: { invoice_id, p_id, month, year, invoice_number } });
  };
  const ViewInvoiceDeduction = (invoice_id, month, invoice_number, year) => {
    navigate(`/${urlParts[3]}/ConsultancyInvoiceDeductions/${p_id}/${invoice_id}/`, { state: { invoice_id, p_id, month, year, invoice_number } });
  };
  const ViewPaymentReceipt = (invoice_id, month, invoice_number, year) => {
    navigate(`/${urlParts[3]}/PrintInvoice/${p_id}/${invoice_id}/`, { state: { invoice_id, p_id, month, year, invoice_number } });
  };

  const role = sessionStorage.getItem('sitemanagement_role');

  const filteredInvoice = invoice?.filter((i) =>
    i.invoice_number?.toString().toLowerCase().includes(searchQuery.toLowerCase()) ||
    i.month?.toString().toLowerCase().includes(searchQuery.toLowerCase()) ||
    i.year?.toString().includes(searchQuery.toLowerCase())
  );

  // ── Dashboard totals ──────────────────────────────────────
  // "Raised" and "Passed" ab list ka sum nahi — latest invoice ke
  // cumulative fields se aayenge (chunki sortedInvoices already
  // year desc, month desc sorted hai, invoice[0] hi latest hai).
  // Field names guessed hain — apna actual invoice JSON bhej de
  // to exact key laga dunga.
  const getAmt = (obj, keys) => {
    for (const k of keys) {
      const v = obj?.[k];
      if (v !== undefined && v !== null && v !== "") return Number(v) || 0;
    }
    return 0;
  };

  const latestInvoice = invoice?.[0]; // sortedInvoices → index 0 = latest month/year

  const dashboardStats = useMemo(() => {
    if (!latestInvoice) return { raised: 0, passed: 0, deducted: 0, released: 0 };

    return {
      // Cumulative raised amount, as stored on the latest invoice record
      raised: getAmt(latestInvoice, [
        "cumulative_amount",
        "cumulative_invoice_amount",
        "total_cumulative_amount",
        "cumulative_raised_amount",
      ]),
      // Cumulative passed/deduction amount, as stored on the latest invoice record
      passed: getAmt(latestInvoice, [
        "cumulative_deduction_amount",
        "cumulative_passed_amount",
        "total_cumulative_deduction",
        "cumulative_deducted_invoice_amount",
      ]),
      // Deducted / released still guessed per-invoice (adjust or remove if not needed)
      deducted: getAmt(latestInvoice, ["deduction_amount", "deducted_amount", "total_deduction"]),
      released: getAmt(latestInvoice, ["released_amount", "payment_amount", "paid_amount"]),
    };
  }, [latestInvoice]);

  // ── Raised invoice download ──────────────────────────────
  const handleDownloadInvoice = (i) => {
    setInvoiceDownloadingId(i.id);
    setInvoiceDownloadTarget({
      invoice_id: i.id, p_id, month: i.month, year: i.year, invoice_number: i.invoice_number,
    });
  };
  const handleInvoiceExportReady = () => {
    setTimeout(() => {
      invoiceExportRef.current?.exportExcel?.();
      setInvoiceDownloadingId(null);
      setInvoiceDownloadTarget(null);
    }, 1500);
  };

  // ── Deduction download ────────────────────────────────────
  const handleDownloadDeduction = (i) => {
    setDeductionDownloadingId(i.id);
    setDeductionDownloadTarget({
      invoice_id: i.id, p_id, month: i.month, year: i.year, invoice_number: i.invoice_number,
    });
  };
  const handleDeductionExportReady = () => {
    setTimeout(() => {
      deductionExportRef.current?.exportExcel?.();
      setDeductionDownloadingId(null);
      setDeductionDownloadTarget(null);
    }, 1500);
  };

  return (
    <>
      <style>{`
        .invc-dash-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 12px;
          margin-bottom: 16px;
        }
        .invc-dash-card {
          background: #f8fafc;
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          padding: 12px 14px;
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
        .invc-dash-label {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 11px;
          font-weight: 600;
          color: #94a3b8;
          text-transform: uppercase;
          letter-spacing: 0.4px;
        }
        .invc-dash-value {
          font-size: 16px;
          font-weight: 700;
          color: #1f2937;
        }
        .invc-dash-card.raised { border-left: 3px solid #2563eb; }
        .invc-dash-card.passed { border-left: 3px solid #16a34a; }
        .invc-dash-card.deducted { border-left: 3px solid #dc2626; }
        .invc-dash-card.released { border-left: 3px solid #7c3aed; }
        @media (max-width: 700px) {
          .invc-dash-grid { grid-template-columns: repeat(2, 1fr); }
        }
      `}</style>

      <button title="View Invoice" className="model-delete-button-modern actionn-icon" style={{ backgroundColor: "#00000075" }} onClick={handleShow}>
        <FileText size={16} color="#fff" />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="lg">
        <Modal.Header className="modern-modal-header">
          <div className="header-content">
            <div style={{ color: "white" }}>
              <ReceiptIndianRupeeIcon size={24} />
            </div>
            <div>
              <Modal.Title>Invoice List</Modal.Title>
              <p className="header-subtitle" style={{ color: "white" }}>
                {project?.project_short_name ? `Invoices for ${project.project_short_name}` : "All invoices for this project"}
              </p>
            </div>
          </div>
          <button className="close-btn" onClick={handleClose}>
            <X size={20} />
          </button>
        </Modal.Header>

        <Modal.Body className="modern-modal-body">
          {!buffer && (
            <>
            </>
            // <div className="invc-dash-grid">
            //   <div className="invc-dash-card raised">
            //     <span className="invc-dash-label"><IndianRupee size={12} /> Total Raised</span>
            //     <span className="invc-dash-value">₹{formatCurrencyIndian(dashboardStats.raised)}</span>
            //   </div>
            //   <div className="invc-dash-card passed">
            //     <span className="invc-dash-label"><CheckCircle size={12} /> Total Passed</span>
            //     <span className="invc-dash-value">₹{formatCurrencyIndian(dashboardStats.passed)}</span>
            //   </div>
            //   <div className="invc-dash-card deducted">
            //     <span className="invc-dash-label"><XCircle size={12} /> Total Deducted</span>
            //     <span className="invc-dash-value">₹{formatCurrencyIndian(dashboardStats.deducted)}</span>
            //   </div>
            //   <div className="invc-dash-card released">
            //     <span className="invc-dash-label"><CloudDownload size={12} /> Total Released</span>
            //     <span className="invc-dash-value">₹{formatCurrencyIndian(dashboardStats.released)}</span>
            //   </div>
            // </div>
          )}

          <div className="table-css-white-background">
            <div className="table-heading-flex">
              <div className="flex-row">
                <div className="table-searchh">
                  <div><Search size={14} color="#2B3674" /></div>
                  <div>
                    <input
                      placeholder="Search"
                      className="navbar-inputt font-weight400 font-size-text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>

            {buffer ? (
              <div className="loader" style={{ width: "100%" }}>
                <div className="child"></div>
              </div>
            ) : (
              <table className="table-css">
                <thead>
                  <tr className="custom-table-head-tr-with-less-padding">
                    <th className="table-heading-text">S.No.</th>
                    <th className="table-heading-text text-center">Invoice Number</th>
                    <th className="table-heading-text text-center">Month</th>
                    <th className="table-heading-text text-center">Year</th>
                    <th className="table-heading-text text-center">View Invoice</th>
                    <th className="table-heading-text text-center">View Invoice Deduction</th>
                    <th className="table-heading-text text-center">Payment Receipt</th>
                    <th className="table-heading-text text-center">Download Invoice Excel</th>
                    <th className="table-heading-text text-center">Download Passed Invoice Excel</th>
                    {role !== "ViewAccess" &&
                      <th className="table-heading-text text-center">Delete Invoice</th>
                    }
                  </tr>
                </thead>
                <tbody>
                  {filteredInvoice?.length > 0 ? (
                    filteredInvoice.map((i, index) => (
                      <tr className="custom-table-head-td" key={index}>
                        <td className="table-body">{index + 1}</td>
                        <td className="table-body text-center">{i.invoice_number}</td>
                        <td className="table-body text-center">{i.month}</td>
                        <td className="table-body text-center">{i.year}</td>
                        <td className="table-body text-center">
                          <button
                            className="model-delete-button-modern actionn-icon"
                            style={{ background: "#00000075" }}
                            onClick={() => ViewInvoice(i.id, i.month, i.invoice_number, i.year)}
                            title="View Invoice Details"
                          >
                            <FileText size={14} color="#fff" />
                          </button>
                        </td>
                        <td className="table-body text-center">
                          <button
                            className="model-delete-button-modern actionn-icon"
                            style={{ background: "#00000075" }}
                            onClick={() => ViewInvoiceDeduction(i.id, i.month, i.invoice_number, i.year)}
                            title="View Invoice Deduction Details"
                          >
                            <FileText size={14} color="#fff" />
                          </button>
                        </td>
                        <td className="table-body text-center">
                          <button
                            className="model-delete-button-modern actionn-icon"
                            style={{ background: "#00000075" }}
                            onClick={() => ViewPaymentReceipt(i.id, i.month, i.invoice_number, i.year)}
                            title="View Payment Receipt Details"
                          >
                            <ReceiptIndianRupeeIcon size={20} color="#fff" />
                          </button>
                        </td>

                        {/* Download raised invoice excel */}
                        <td className="table-body text-center">
                          <button
                            className="model-delete-button-modern actionn-icon"
                            style={{ background: invoiceDownloadingId === i.id ? "#1e7e34" : "#1e7e34", borderRadius: invoiceDownloadingId === i.id ? "5px" : "10px" }}
                            onClick={() => handleDownloadInvoice(i)}
                            disabled={invoiceDownloadingId === i.id}
                            title="Download Invoice Excel"
                          >
                            {invoiceDownloadingId === i.id
                              ? <span className="loader actionn-icon" style={{ color: "#fff", background: invoiceDownloadingId === i.id ? "#1e7e34" : "#1e7e34" }} ><CloudDownload size={14} color="#fff" />Downloading...</span>
                              : <CloudDownload size={14} color="#fff" />
                            }
                          </button>
                        </td>

                        {/* Download deduction excel */}
                        <td className="table-body text-center">
                          <button
                            className="model-delete-button-modern actionn-icon"
                            style={{ background: deductionDownloadingId === i.id ? "#1e7e34" : "#1e7e34", borderRadius: deductionDownloadingId === i.id ? "5px" : "10px" }}
                            onClick={() => handleDownloadDeduction(i)}
                            disabled={deductionDownloadingId === i.id}
                            title="Download Passed Invoice Excel"
                          >
                            {deductionDownloadingId === i.id
                              ? <span className="loader actionn-icon" style={{ color: "#fff", background: deductionDownloadingId === i.id ? "#1e7e34" : "#1e7e34" }} ><CloudDownload size={14} color="#fff" />Downloading...</span>
                              : <CloudDownload size={14} color="#fff" />
                            }
                          </button>
                        </td>

                        {role !== "ViewAccess" &&
                          <td className="table-body text-center">
                            {(role === "Checker" && !isMoreThan24Hours(i.created_at)) || role !== "Checker" ? (
                              <DeleteInvoice i={i} getInvoice={getInvoice} />
                            ) : (
                              "-"
                            )}
                          </td>
                        }
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={role !== "ViewAccess" ? 9 : 8} className="align-center">
                        No invoices found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>

          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>

      {deductionDownloadTarget && (
        <div style={{ position: "absolute", left: "-9999px", top: 0 }}>
          <ConsultancyInvoiceFormat
            ref={deductionExportRef}
            usefor="downloadOnly"
            p_id={deductionDownloadTarget.p_id}
            invoice_id={deductionDownloadTarget.invoice_id}
            month={deductionDownloadTarget.month}
            year={deductionDownloadTarget.year}
            invoice_number={deductionDownloadTarget.invoice_number}
            onExportReady={handleDeductionExportReady}
          />
        </div>
      )}

      {invoiceDownloadTarget && (
        <div style={{ position: "absolute", left: "-9999px", top: 0 }}>
          <ConsultancyInvoiceFormat
            ref={invoiceExportRef}
            usefor="downloadOnly"
            p_id={invoiceDownloadTarget.p_id}
            invoice_id={invoiceDownloadTarget.invoice_id}
            month={invoiceDownloadTarget.month}
            year={invoiceDownloadTarget.year}
            invoice_number={invoiceDownloadTarget.invoice_number}
            onExportReady={handleInvoiceExportReady}
          />
        </div>
      )}
    </>
  );
};

export default InvoiceList;